/**
 * AppICEMAP — OfflineBanner
 * Fixed-top banner showing when the app is offline.
 *
 * Usage:
 *   <offline-banner></offline-banner>
 *
 * Reads online/offline state from store and navigator.onLine.
 */

import { state, subscribe } from "../../store/index.js";

export class OfflineBanner extends HTMLElement {
	constructor() {
		super();
		this._unsubscribe = null;
	}

	connectedCallback() {
		this._render();
		this._updateVisibility();

		// Subscribe to store
		this._unsubscribe = subscribe("offline", () => this._updateVisibility());

		// Listen to browser events
		window.addEventListener("online", () => this._updateVisibility());
		window.addEventListener("offline", () => this._updateVisibility());
	}

	disconnectedCallback() {
		if (this._unsubscribe) this._unsubscribe();
	}

	_render() {
		this.className = "offline-banner";
		this.setAttribute("role", "alert");
		this.setAttribute("hidden", "");

		const icon = document.createElement("i");
		icon.className = "ph ph-wifi-slash";
		icon.setAttribute("aria-hidden", "true");
		this.appendChild(icon);

		const text = document.createElement("span");
		text.className = "offline-banner__text";
		text.textContent = "Sin conexión";
		this.appendChild(text);
	}

	_updateVisibility() {
		const isOffline = state.offline || !navigator.onLine;

		if (isOffline) {
			this.removeAttribute("hidden");

			// Show last sync time if available
			const textEl = this.querySelector(".offline-banner__text");
			if (textEl && state.ui.lastSyncTime) {
				const minutes = Math.round(
					(Date.now() - state.ui.lastSyncTime.getTime()) / 60000,
				);
				textEl.textContent =
					minutes < 1
						? "Sin conexión — datos recientes"
						: `Sin conexión — datos de hace ${minutes} min`;
			} else if (textEl) {
				textEl.textContent = "Sin conexión";
			}
		} else {
			this.setAttribute("hidden", "");
		}
	}
}

customElements.define("offline-banner", OfflineBanner);
